import React from "react";
import { Tooltip } from "@mui/material";

export default function Icon({
  name,
  tooltip,
  noSideGap,
  fillCurrent,
  display,
}: {
  name: string;
  tooltip?: string;
  noSideGap?: boolean;
  fillCurrent?: boolean;
  display?: string;
}) {
  switch (name) {
    case "bnb":
      return (
        <Tooltip title={tooltip}>
          <svg className="icon h-4 w-4 mr-1 flex-shrink-0">
            <use xlinkHref="/icons.svg#icon-BNB" />
          </svg>
        </Tooltip>
      );
    case "wbnb":
      return (
        <Tooltip title={tooltip}>
          <svg className="icon h-5 w-5 mr-1 flex-shrink-0">
            <use xlinkHref="/icons.svg#icon-WBNB" />
          </svg>
        </Tooltip>
      );
    default:
      return (
        <Tooltip title={tooltip}>
          <svg
            className={`icon h-4 w-4 ${noSideGap ? "" : "mr-1"} flex-shrink-0 ${
              fillCurrent ? "fill-current" : ""
            } ${display ? display : ""}`}
          >
            <use xlinkHref={`/icons.svg#${name}`} />
          </svg>
        </Tooltip>
      );
  }
}

// export const ChainIcon = ({
//   name,
//   tooltip,
//   width,
//   sideGap,
// }: {
//   name: string;
//   tooltip?: string;
//   width?: string;
//   sideGap?: boolean;
// }) => {
//   return (
//     <Tooltip title={tooltip}>
//       <svg
//         className={`icon flex-shrink-0 ${sideGap ? "mr-1" : ""}`}
//         style={{
//           width: width || "1rem",
//           height: width || "1rem",
//         }}
//       >
//         <use xlinkHref={`/icons.svg#chain-${name}`} />
//       </svg>
//     </Tooltip>
//   );
// };

export const ChainIcon = ({
  name,
  tooltip,
  width,
  sideGap,
  className,
  placement,
  type = "token",
  pt = 0,
}: {
  name: string;
  tooltip?: string;
  width?: string | number;
  sideGap?: boolean;
  className?: string;
  placement?: any;
  type?: string;
  pt?: number;
}) => {
  return (
    <Tooltip title={tooltip} className={className} placement={placement}>
      <svg
        className={`icon flex-shrink-0 ${sideGap ? "mr-1" : ""} ${
          pt ? `pt-${pt}` : ""
        }`}
        style={{
          width: width || 16,
          height: width || 16,
        }}
      >
        <use xlinkHref={`/icons.svg#${type}-${name}`} />
      </svg>
    </Tooltip>
  );
};
